import { Box } from 'components/common/Box';
import { Typography } from 'components/common/Typography';
import styled from 'styled-components';
import { COLORS } from 'theme/colors';
import { SIZES } from 'theme/sizes';

export const StyledInnerContainer = styled(Box)`
  padding-top: ${SIZES.spacing(2)};

  ${SIZES.media.phone} {
    padding-top: ${SIZES.spacing(3)};
  }
`;

export const StyledName = styled(Typography)`
  font-size: 18px;
  line-height: 20px;
  color: ${COLORS.typography.primary};
  margin-bottom: 4px;

  ${SIZES.media.phone} {
    font-size: 24px;
    line-height: 26px;
    margin-bottom: 10px;
  }
`;

export const StyledPosition = styled(Typography)`
  font-size: 12px;
  line-height: 17px;

  ${SIZES.media.phone} {
    font-size: 14px;
    line-height: 20px;
  }
`;

export const StyledLinkedinLink = styled.a`
  transition-duration: 0.2s;
  flex: 0 1 12%;

  &:hover {
    svg {
      fill: ${COLORS.info.selectedBorder};
    }
  }
`;

export const StyledPhoto = styled.img`
  width: 100%;
  brder-radius: 16px;
`;
